import { useAuth } from 'oidc-react';
import { useLazyGetActiveProjectStateQuery } from './api/GraphAPI';
import { setProjectState } from './state/slices/ProjectStateSlice';
import { store } from './state/Store';
import { useEffect } from 'react';
import { toaster } from '../components/ui/toaster';

export default function LoadAppStateFromServer() {
  const [trigger, { isSuccess, isError, isLoading, data, error }, lastPromiseInfo] =
    useLazyGetActiveProjectStateQuery();
  const auth = useAuth();

  useEffect(() => {
    trigger();
    if (isSuccess && data && data.length > 0) {
      // console.log(data[0]);
      let projectState = data[0].json;
      store.dispatch(setProjectState(projectState));
    }
  }, [auth.userData?.profile.sub, isSuccess, data]);

  useEffect(() => {
    if (isError && error) {
      toaster.create({
        title: 'Error fetching project',
        description: `Unable to fetch current project at this moment: ${JSON.stringify(error)}. Retrying...`,
        status: 'error',
        // duration: 3000,
        duration: null,
        isClosable: true,
      });
    }
  }, [isError, error]);

  return null;
}
